import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
import FirmSubUsers from './FirmSubUsers';
import ThemeContext from "../../context/ThemeContext";

const GET_POST = gql`
query MyQuery($firmCode: String!) {
    tbl_firm_sub(where: { firm_sub_code: { _eq: $firmCode } }) {
        firm_main_code
        firm_sub_code
        firm_sub_name
        firm_sub_type
        place
        active
    }
  }
 
`; 

const UPDATE_FIRM = gql`
  mutation UpdateFirm(
    $firmCode: String!
    $firmName: String!
    $firmType: String!
    $place: Int!
  ) {
    update_tbl_firm_sub(
      where: { firm_sub_code: { _eq: $firmCode } },
      _set: { firm_sub_name: $firmName, firm_sub_type: $firmType, place: $place }
    ) {
      affected_rows
    }
  }
`;









const FirmSubUpdate = () => {


const {theme, setTheme} = useContext(ThemeContext);

  const { firm_sub_code } = theme;
  console.log(theme);
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { firmCode: theme },
  });
  const [updateFirm] = useMutation(UPDATE_FIRM);

  const firmData = data && data.tbl_firm_sub ? data.tbl_firm_sub[0] : null;

  
  const [firmName, setFirmName] = useState(firmData ? firmData.firm_name : "");
  
  const [firmType, setFirmType] = useState(firmData ? firmData.firm_type : "");  
  const [place, setPlace] = useState(firmData ? firmData.place : "");
  console.log("Firm Data:", firmData);

  useEffect(() => {
    if (firmData) {
      setFirmName(firmData.firm_sub_name);
      setFirmType(firmData.firm_sub_type);
      setPlace(firmData.place);
    }
  }, [firmData]);

  const handleUpdate = () => {
    updateFirm({
      variables: {
        firmCode: firmData.firm_sub_code,
        firmName: firmName,
        firmType: firmType,
        place: place
      },
    })
      .then(() => {
        window.alert("Firm updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (!firmData) {
    return <p>No firm data found.</p>;
  }
  
  

  return (
    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
      <h2 className="mb-4 text-2xl font-semibold leading-tight">Sub Firm Details</h2>

      <div className="mt-4">
        <label htmlFor="firmCode" className="block font-medium text-gray-700">
          Firm Code
        </label>
        <input
          type="text"
          id="firmCode"
          name="firmCode"
          value={firmData.firm_sub_code}
          className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
          readOnly
        />
      </div>

      <div className="mt-4">
        <label htmlFor="firmName" className="
block font-medium text-gray-700">
Firm Name
</label>
<input
type="text"
id="firmName"
name="firmName"
value={firmName}
onChange={(e) => setFirmName(e.target.value)}

className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
/>
</div>
<div className="mt-4">
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      Firm Type
    </label>
    <input
      type="text"
      id="firmType"
      name="firmType"
      value={firmType}
      onChange={(e) => setFirmType(e.target.value)}
      className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
    />
  </div>

  <div className="mt-4">
    <label htmlFor="place" className="block font-medium text-gray-700">
      Place
    </label>
    <input
      type="text"
      id="place"
      name="place"
      value={place}
      onChange={(e) => setPlace(e.target.value)}
      className="mt-1 px-4 py-2 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block w-full rounded-md"
    />
  </div>

  <div className="mt-4">
    <button
      className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded-md"
      onClick={handleUpdate}
    >
      Update
    </button>
  </div>
</div>
);
};

export default FirmSubUpdate;
